/* External Imports */
import { Box, Image, Link } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import { refineUrlDomain } from '@components/Utility/utils';
import { useMediaQuery } from 'react-responsive';
/* Services */

/**
 * Renders the Banner component
 * @param {Object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} Banenr component
 */

const Banner = (sectionContent, region, lang) => {
  const moduledata = sectionContent?.pageBody;
  const isMobile = useMediaQuery({ maxWidth: 320 });
  return (
    <Box as="div" mb={{ base: '30px' }}>
      <Box as="div" backgroundColor="#893101">
        <Box
          as="div"
          display={{ base: 'block', sm: 'flex', md: 'flex', lg: 'flex' }}
          padding={{
            sm: '0 0 0 0',
            base: '0 0 0 0',
            md: '0 0 0 50px',
            lg: '0 0 0 50px',
          }}
          alignItems="center"
          minHeight={{ base: '520px', sm: '260px' }}
        >
          <Box display={{ base: 'block', sm: 'block', md: 'none', lg: 'none' }}>
            <Image
              src={moduledata[0]?.mobileImage?.url}
              alt={moduledata[0]?.mobileImage?.alt}
              title={moduledata[0]?.mobileImage?.title}
              fallbackSrc={moduledata[0]?.image?.url}
              width="100%"
              clipPath="polygon(0 0, 100% 0, 100% 94%, 0% 100%)"
            />
          </Box>
          <Box
            color="#ffffff"
            textAlign={{ base: 'left', sm: 'left', md: 'left', lg: 'left' }}
            width={{ base: '90%', sm: '90%' }}
            m="0 auto"
          >
            <Box
              as="h1"
              fontFamily="FedraSerifAStdBook"
              fontWeight={{ base: '600', md: '600' }}
              fontSize={{
                base: '30px',
                md: '42px',
              }}
              padding="20px 0 0 0"
              width={isMobile ? '89%' : { base: '68%', sm: '70%', md: '60%' }}
              lineHeight={{ base: '39px', md: '52px' }}
            >
              {moduledata[1]?.titleText}
            </Box>
            <Box
              as="h2"
              fontFamily="FedraSansStd-book"
              fontWeight={{ base: '600', sm: '600', md: '700' }}
              fontSize={{
                base: '18px',
                md: '17px',
              }}
              padding={{ base: '10px 0 10px 0', md: '0' }}
              width={{ base: '100%', sm: '100%', md: '60%' }}
              lineHeight="22px"
            >
              {moduledata[1]?.titleSubtext}
            </Box>
            <Box
              as="div"
              m={{ base: '10px auto 0 0', md: '10px auto 0 auto' }}
              width={{ base: '95%', sm: '95%', md: '100%' }}
              fontSize={{ base: '16px', md: '16px' }}
              fontWeight="400"
              lineHeight="24px"
            >
              {StructuredTextContent(moduledata[3]?.body?.value)}
            </Box>
            <Image
              src={moduledata[2]?.image?.url}
              m="18px 0"
              title={moduledata[2]?.image?.title}
              fallbackSrc={moduledata[2]?.image?.url}
              alt={moduledata[2]?.image?.alt}
            />
            <Box
              as="div"
              className="bannercontent"
              width={{ base: '90%', sm: '90%', md: '74%' }}
              textAlign={{ base: 'center', md: 'left' }}
              fontSize={{ base: '16px', md: '16px' }}
              lineHeight={{ base: '22.4px', md: '22.4px' }}
            >
              {StructuredTextContent(moduledata[4]?.body?.value)}
            </Box>
            {moduledata[5]?.buttonText !== null && (
              <>
                <Box
                  display={{ base: 'flex', md: 'block' }}
                  placeContent={{ base: 'center', md: 'left' }}
                >
                  <Box
                    as="button"
                    m={{
                      base: '40px 0 10px 0',
                    }}
                    width="200px"
                    height="54px"
                    fontFamily="FedraSansStd-medium"
                    backgroundColor="#ffffff"
                    fontWeight="normal"
                    color="#A81B14"
                    padding="10px 30px"
                    borderRadius="10px"
                    _hover={{
                      textDecoration: 'none',
                      bgColor: '#cf4520',
                      color: 'white',
                    }}
                  >
                    <Link
                      href={refineUrlDomain(
                        moduledata[5]?.linkUrl,
                        region,
                        lang
                      )}
                    >
                      {moduledata[5]?.linkUrl != null && (
                        <>{moduledata[5]?.buttonText}</>
                      )}
                    </Link>
                  </Box>
                </Box>
              </>
            )}
            <Box
              as="p"
              fontSize="14px"
              pt="16px"
              pb="15px"
              className="text-underline"
              _active={{ color: '#ffffff' }}
            >
              {StructuredTextContent(moduledata[7]?.body?.value)}
            </Box>
            {/* <Box
              as="div"
              textAlign="center"
              pb="30px"
              width={{ base: '100%' }}
              className="sadhgurubanner_quote"
              display={{ base: 'block', sm: 'block', md: 'none', lg: 'none' }}
            >
              {StructuredTextContent(moduledata[6]?.body?.value)}
            </Box> */}
          </Box>
          <Box
            display={{ base: 'none', sm: 'none', md: 'block', lg: 'block' }}
            marginLeft={{ base: '0', sm: '0', md: 'auto', lg: 'auto' }}
            className="banner_desktop"
          >
            <Image
              src={moduledata[0]?.image?.url}
              fallbackSrc={moduledata[0]?.image?.url}
              title={moduledata[0]?.image?.title}
              alt={moduledata[0]?.image?.alt}
              web
              height="auto"
              width="1045px"
            />
          </Box>
        </Box>
      </Box>
      <Box
        as="div"
        textAlign="center"
        m="0 auto"
        mt={{ base: '30px', md: '50px' }}
        className="sadhguru_quote"
        width={{ base: '85%', md: 'auto' }}
        // display={{ base: 'none', sm: 'none', md: 'block', lg: 'block' }}
      >
        {StructuredTextContent(moduledata[6]?.body?.value)}
        <Box mt="30px">
            <Image
              src={moduledata[7]?.image?.url}
              alt={moduledata[7]?.image?.alt}
              title={moduledata[7]?.image?.title}
              fallbackSrc={moduledata[7]?.image?.url}
            />
        </Box>
      </Box>
      <style global jsx>
        {`
          .banner_desktop img {
            -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 18% 100%);
            clip-path: polygon(0 0, 100% 0, 100% 100%, 18% 100%);
          }
          .sadhguru_quote mark,
          .sadhgurubanner_quote mark,
          .bannercontent mark {
            background: transparent;
            font-weight: bold;
            line-height: 55px;
          }
          .bannercontent mark {
            color: #ffffff;
          }
          .sadhgurubanner_quote mark {
            color: #ffffff;
          }
          .bannercontent p {
            line-height: 29px;
          }
          @media screen and (max-width: 768px) {
            .bannercontent p {
              text-align: left;
              padding: 0 10px 0 0;
            }
            .bannercontent p {
              padding-top: 16px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default Banner;
